import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/system';

const StyledOTPTextField = styled(TextField)(({ theme }) => ({
  width: '58px',
  '& .MuiOutlinedInput-root': {
    background: '#23232A',
    borderRadius: '8px',
    '& fieldset': {
      borderColor: '#fff',
    },
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
    '& input': {
      color: '#fff',
      textAlign: 'center',
      fontSize: 24,
    },
  },
}));

export interface OTPInputProps extends Omit<TextFieldProps, 'variant'> {
  index: number;
  onInputChange: (index: number, event: any) => void;
  inputRef: (el: any) => void;
}

export const OTPInput: React.FC<OTPInputProps> = ({
  index,
  onInputChange,
  inputRef,
  ...props
}) => {
  return (
    <StyledOTPTextField
      placeholder=""
      variant="outlined"
      inputProps={{
        maxLength: 1,
        inputMode: 'numeric',
        pattern: '[0-9]*',
        style: { color: '#fff', textAlign: 'center', fontSize: 24 },
      }}
      onChange={(event) => onInputChange(index, event)}
      inputRef={inputRef}
      {...props}
    />
  );
};

export default OTPInput;
